import React, { PropsWithChildren } from "react";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material";
import Typography from "../Typography";

type PropertyItemProps = {
  name: string;
  status?: string;
  statusDetails?: string;
  endButton?: React.JSX.Element;
};

const Container = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.highlight,
  border: `1px solid ${theme.palette.background.highlight}`,
  borderRadius: theme.shape.borderRadius,
  paddingRight: 0,
}));

const Element = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  paddingLeft: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
}));

const PropertyItem = (props: PropsWithChildren<PropertyItemProps>) => {
  const { name, children, status, statusDetails, endButton } = props;

  return (
    <Container
      container
      sx={{
        width: "100%",
      }}
      direction="row"
      alignItems="center"
    >
      <Grid
        sx={{
          width: "40%",
        }}
      >
        <Typography
          tooltip={name}
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            paddingLeft: "0.5em",
          }}
        >
          {name}
        </Typography>
      </Grid>
      <Element width="60%">
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid
            sx={{
              flexGrow: status ? 0 : 1,
              overflow: "hidden",
            }}
          >
            {children}
          </Grid>
          {status && (
            <Typography
              tooltip={statusDetails}
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingLeft: "0.5em",
              }}
            >
              {status}
            </Typography>
          )}
          {endButton}
        </Grid>
      </Element>
    </Container>
  );
};

export default PropertyItem;
